
import { Vue, Component } from 'vue-property-decorator';
import { Base64 } from 'js-base64';
// import Log from '@/plugin/db/index';
import api from '@/api/app';

@Component
export default class App extends Vue {
  private logImg?: string;

  private flag: boolean = false;

  private notice: any = null;

  mounted() {
    Notification.requestPermission().then((result: string) => {
      if (result === 'granted') this.flag = true;
    });
    window.addEventListener('offline', () => {
      this.systemNotice('网络连接已断开', '您的网络已断开, 请及时修复网络');
      this.msg('网络连接已断开', 'warning');
    });
    window.addEventListener('online', () => {
      this.systemNotice('网络连接已恢复', '您的网络已经恢复啦, 欢迎回来');
      this.msg('网络连接已连接', 'info');
    });
  }

  systemNotice(title: string, body: string) {
    this.notice = new Notification(title, {
      body,
      tag: 'network',
      /* eslint-disable global-require */
      icon: require('./assets/imgs/logo-small.png'),
      requireInteraction: true,
    });
  }

  /* eslint-disable class-methods-use-this */
  destroyed() {
    window.removeEventListener('offline', () => {});
    window.removeEventListener('online', () => {});
  }
}
